import { render } from "./HeroiconsOutlineMenuAlt3.vue?vue&type=template&id=6a9c0024"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMenuAlt3.vue"]])

export default __exports__